import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Gallery() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-93">
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-palomitas-pink/8 rounded-full blur-3xl" data-id="element-94"></div>
      <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-palomitas-orange/8 rounded-full blur-3xl" data-id="element-95"></div>

      <div className="container px-4 mx-auto max-w-5xl relative z-10" data-id="element-96">
        <div className="text-center mb-12" data-id="element-97">
          <span className="inline-flex items-center gap-2 bg-palomitas-pink/15 text-palomitas-pink px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-4" data-id="element-98">
            <Sparkles size={16} data-id="element-99" />
            <span data-id="element-100">📸 Galería Premium</span>
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-palomitas-brown mb-4" data-id="element-101">
            Sabores que enamoran a tus clientes
          </h2>
          <p className="text-xl text-gray-600" data-id="element-102">
            Creá productos irresistibles con calidad premium
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="rounded-3xl overflow-hidden shadow-2xl border-4 border-palomitas-pink/20" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/jDPpfbvtEpfWRnXiyY9TwU/WhatsApp_Image_2026-04-30_at_02.13.30.jpg" alt="Galería de sabores de palomitas gourmet" className="w-full h-auto object-cover" data-id="element-104" />
        </motion.div>
      </div>
    </section>;
}